import { createFileRoute } from '@tanstack/react-router'
import { LendAssetsPage } from '@/features/lend/assets/LendAssetsPage'

export const Route = createFileRoute('/_app/lend/assets')({
  component: LendAssetsPage,
})
